import React from "react";
import "../../assets/css/certificado.css";
import onac from "../../assets/img/LOGO-ONAC-Producto-17065-BN.png";
import icontec from "../../assets/img/LOGO-Icontec-2019_ver_black.png";

const CertificatePDF = () => {
  return (
    <div>
      <div id="certificate-content">
        <table className="custom-table">
          <tbody>
            <tr>
              <td width="50%" valign="top">
                <div className="report-form">
                  <header className="report-form-header">
                    <table className="header-table">
                      <tbody>
                        <tr className="icontec-bg::before">
                          <td>
                            <h1>
                              REPORTE DE INSPECCIÓN DE INSTALACIÓN DEL EQUIPO
                              PARA GAS NATURAL COMPRIMIDO EN VEHÍCULOS
                            </h1>
                          </td>
                          <td className="header-image">
                            <img src={icontec} width={100} alt="Icontec" />
                          </td>
                          <td className="header-image">
                            <img src={onac} width={120} alt="Onac" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="header-info">
                      <div className="left">
                        <p>
                          <strong>GNCV 0957</strong>
                        </p>
                      </div>
                      <div className="right"></div>
                    </div>
                  </header>
                  <section className="form-section">
                    <div className="form-row">
                      <label>Fecha de Expedición:</label>
                      <input type="text" placeholder="Año" />
                      <input type="text" placeholder="Mes" />
                      <input type="text" placeholder="Día" />
                    </div>
                    <div className="form-row">
                      <label>Fecha de Vencimiento:</label>
                      <input type="text" placeholder="Año" />
                      <input type="text" placeholder="Mes" />
                      <input type="text" placeholder="Día" />
                    </div>
                    <div className="form-row">
                      <label>Ciudad de Expedición:</label>
                      <input type="text" />
                    </div>
                    <div className="form-row">
                      <label>Solicitado por:</label>
                      <input type="text" />
                    </div>
                    <div className="form-row">
                      <label>Vehículo:</label>
                      <input type="text" placeholder="Placa" />
                      <input type="text" placeholder="Marca" />
                      <input type="text" placeholder="Modelo" />
                    </div>
                    <div className="form-row">
                      <label>Tipo de Revisión:</label>
                      <input type="text" placeholder="Inicial" />
                      <input type="text" placeholder="Anual" />
                    </div>
                  </section>

                  <section className="cylinder-section">
                    <h2>CILINDROS INSTALADOS</h2>
                    <table>
                      <thead>
                        <tr>
                          <th>CANT.</th>
                          <th>MARCA</th>
                          <th>SERIAL</th>
                          <th>FECHA FABRIC.</th>
                          <th>ÚLTIMA PRUEBA</th>
                          <th>MARCA DEL KIT</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                          <td>
                            <input type="text" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>

                  <footer className="report-footer">
                    <div className="footer-info">
                      <label>Cert. Original</label>
                      <input type="text" />
                    </div>
                    <div className="footer-info">
                      <label>Duplicado</label>
                      <input type="text" />
                    </div>
                  </footer>
                </div>
              </td>
              <td>
                <div className="report-form">
                  <header className="report-form-header">
                    <h1>CARACTERÍSTICAS EVALUADAS</h1>
                    <div className="header-info">
                      <div className="">
                        <p className="justificado">
                          <label>
                            INSTALACIÓN DE CILINDROS, INSTALACIÓN DE TUBERÍAS,
                            MANGUERAS Y ACCESORIOS, INSTALACIÓN DEL REGULADOR DE
                            PRESIÓN, INSTALACIÓN DE VÁLVULAS, INSTALACIÓN DEL
                            SELECTOR DE COMBUSTIBLE, INSTALACIÓN DEL INDICADOR
                            DE PRESIÓN, INSTALACIÓN DEL MEZCLADOR, INSTALACIÓN
                            DE LA INTERFAZ PARA EL SISTEMA DE INFORMACIÓN Y
                            PRUEBAS Y REVISIONES.
                          </label>
                        </p>
                      </div>
                    </div>
                  </header>
                  <p>
                    <td className="header-image icontec-bg">
                      <div className="icontec-content">
                        <h4>
                          NOTAS <br />
                          1. EL PRESENTE REPORTE DE INSPECCIÓN IMPLICA JUICIO
                          ÚNICA Y EXCLUSIVAMENTE SOBRE LA INSTALACIÓN DEL EQUIPO
                          COMPLETO DELVEHÍCULO INDICADO. <br />
                          2. ELPRESENTE REPORTE DE INSPECCIÓN PIERDE VALIDEZ CON
                          CUALQUIER CAMBIO O ADICIÓN QUE SE REALICE EN LA
                          INSTALACIÓN DELEQUIPO DE CONVERSIÓN EN ELVEHÍCULO
                          LUEGO DE REALIZADALAINSPECCIÓN. <br />
                          3. EL ORGANISMO DE CERTIFICACIÓN NO PUEDE RELEVAR DE
                          SU RESPONSABILIDAD A LOS FABRICANTES DEL EQUIPO
                          COMPLETO INSTALADO EN EL VEHÍCULO NI AL INSTALADOR DEL
                          EQUIPO. TAMPOCO PUEDE ASUMIR RESPONSABILIDADES
                          ECONÓMICAS QUE EXCEDAN ELVALOR FACTURADO DELSERVICIO.
                          <br /> 4. EN CASO DE PRESENTARSE DISCREPANCIAO DUDACON
                          RESPECTO ALOS RESULTADOS OBTENIDOS, SE DISPONE DE UN
                          PROCEDIMIENTO DE APELACIÓN .<br /> 5. LOS PERJUICIOS
                          QUE SE PUEDAN DERIVAR DEL USO INDEBIDO QUE SE LE DÉ A
                          ESTE DOCUMENTO SERÁN RESPONSABILIDAD DELSOLICITANTE
                          INDICADO. <br />
                          6. ESTE DOCUMENTO NO ES VÁLIDO EN CASO DE PRESENTAR
                          CUALQUIER TIPO DE ALTERACIÓN O ENMENDADURA. <br />
                          7. ESTE DOCUMENTO ES VÁLIDO ÚNICAMENTE EN ORIGINALY
                          CON LAFIRMARESPECTIVA.
                          <br /> 8. ICONTEC NO ASUME RESPONSABILIDAD ALGUNA POR
                          MODIFICACIONES, ALTERACIONES O MANIPULACIÓN DEL EQUIPO
                          INSTALADO Y CUYAS NUEVAS CARACTERÍSTICAS NO HAYAN SIDO
                          OBJETO DE LAEVALUACIÓN POR PARTE DE ICONTEC
                        </h4>
                      </div>
                    </td>
                  </p>
                  <br />
                  <footer className="report-footer">
                    <div className="footer-info">
                      <label>Firma Autorizada</label>
                      <input type="text" />
                    </div>
                  </footer>
                  <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CertificatePDF;
